import { RemoteUpdateEvaluationCriteria } from 'data/usecases';
import { makeApiUrlEvaluationCriteria } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateEvaluationCriteria =
  (): RemoteUpdateEvaluationCriteria => {
    return new RemoteUpdateEvaluationCriteria(
      makeApiUrlEvaluationCriteria(),
      makeAxiosHttpClient(),
    );
  };
